import * as Yup from "yup";

export const triggerImportSchema = Yup.object().shape({
  osFile: Yup.mixed().required("OS POI File is required").nullable(),
  description: Yup.string().required("A description must be set")
});